import Upload from 'helpers/Upload.ts'
import Funcs from 'helpers/Functions.ts'

export const buffer2Base64 = (
	arrayBuffer: ArrayBuffer,
	mimetype = 'image/jpeg'
) => {
	if (typeof arrayBuffer === 'undefined' || arrayBuffer.byteLength === 0) {
		return undefined
	}
	const b64encoded = btoa(
		[].reduce.call(
			new Uint8Array(arrayBuffer),
			function (p, c) {
				return p + String.fromCharCode(c)
			},
			''
		)
	)
	return 'data:' + mimetype + ';base64,' + b64encoded
}

const Func = { ...Funcs, ...Upload }

export default Func
